import { render } from "./ArticleReaderControls.vue?vue&type=template&id=5d281a5d"
import script from "./ArticleReaderControls.vue?vue&type=script&lang=js"
export * from "./ArticleReaderControls.vue?vue&type=script&lang=js"

import "./ArticleReaderControls.vue?vue&type=style&index=0&id=5d281a5d&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__